import { MqSwitch } from '@fhs/ui';

import { ActionTileMobile } from './action-tile-mobile';
import { ActionTileDesktop } from './action-tile.desktop';
import { ActionTileProps } from './types';

export function ActionTile(props: ActionTileProps) {
  return (
    <MqSwitch
      $ltDesktop={() => <ActionTileMobile {...props} />}
      $gteDesktop={() => <ActionTileDesktop {...props} />}
    />
  );
}
